export const MOXTRA_BASE_URL = "https://juniper.moxtra.com/";
export const JUNIPER_DOMAIN = "junipercreates.com";
